import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { Button, Card, Icon, Image } from 'semantic-ui-react'
import LoadingComponent from '../../../app/layout/LoadingComponents'
import { useStore } from '../../../app/stores/ardstore'

export default observer(function ArduinoDetails () {
  const { arduinoStore } = useStore()
  const {
    selectedArduino: arduino,
    loadArduino,
    loadingInitial
  } = arduinoStore
  const { id } = useParams<{ id: string }>()

  useEffect(() => {
    if (id) {
      loadArduino(id)
    }
  }, [id, loadArduino])

  if (loadingInitial || !arduino) { return <LoadingComponent content="Loading..." /> }

  return (
    <Card fluid>
      {/* <Image src={`/assets/categoryImages/${arduino.category}.jpg`} /> */}
      <Card.Content>
        <Card.Header>Arduino number: {arduino.id}</Card.Header>
        <Card.Meta>
          {/* <span>{arduino.date}</span> */}
        </Card.Meta>
        <Card.Description>{arduino.value}</Card.Description>
      </Card.Content>
      <Card.Content extra>
        <Button.Group widths="2">
          <Button
            as={Link}
            to={`/editArduino/${arduino.id}`}
            basic
            color="blue"
            content="Edit"
          />
          <Button
            as={Link}
            to="/arduinos"
            basic
            color="grey"
            content="Cancel"
          />
        </Button.Group>
      </Card.Content>
    </Card>
  )
})
